import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, unref as _unref, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a9bf6fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Payment", -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back to Booking ")
const _hoisted_4 = { class: "booking-info" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" View Booking ")
const _hoisted_6 = {
  key: 2,
  class: "payment-form"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Step 1: Authorize Credit Card", -1))
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Cardholder Name", -1))
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Card Number", -1))
const _hoisted_15 = { class: "form-row" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Expiry Month", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Expiry Year", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "CCV", -1))
const _hoisted_24 = { class: "form-row" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Amount ($)", -1))
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 3,
  class: "payment-form"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Step 2: Confirm Payment", -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Card authorized successfully. Payment ID: ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Amount: ")
const _hoisted_32 = ["disabled"]

import { computed, ref } from "vue";
import api from "@virgodev/bazaar/functions/api";


export default /*#__PURE__*/_defineComponent({
  props: {
    bookingId: null,
    facilityId: null,
    facilityName: null
  },
  setup(__props: any) {

const props = __props as {
  bookingId: string;
  facilityId: string;
  facilityName?: string;
}



const step = ref(1);
const paymentId = ref<number | null>(null);
const submitting = ref(false);
const errorMessage = ref("");
const successMessage = ref("");

const cardName = ref("");
const cardNumber = ref("");
const expiryMonth = ref("01");
const expiryYear = ref(String(new Date().getFullYear()));
const ccv = ref("");
const amount = ref("");

const yearOptions = computed(() => {
  const current = new Date().getFullYear();
  return Array.from({ length: 12 }, (_, i) => current + i);
});

async function authorizeCard() {
  errorMessage.value = "";
  submitting.value = true;

  try {
    const response = await api({
      url: `nb/cc_auth/?facilityId=${props.facilityId}`,
      method: "POST",
      json: {
        booking_id: Number(props.bookingId),
        card_number: cardNumber.value.replace(/\s/g, ""),
        card_expiry_month: expiryMonth.value,
        card_expiry_year: expiryYear.value,
        card_ccv: ccv.value,
        card_name: cardName.value,
        amount: amount.value,
      },
    });

    if ("body" in response && [200, 201].includes(response.status)) {
      paymentId.value =
        response.body?.data?.payment_id || response.body?.data?.id || null;
      if (paymentId.value) {
        step.value = 2;
      } else {
        errorMessage.value =
          "Authorization succeeded but no payment ID returned.";
      }
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Card authorization failed.";
    }
  } catch {
    errorMessage.value = "An error occurred during card authorization.";
  }

  submitting.value = false;
}

async function processPayment() {
  if (!paymentId.value) return;
  errorMessage.value = "";
  submitting.value = true;

  try {
    const response = await api({
      url: `nb/payment/?facilityId=${props.facilityId}`,
      method: "POST",
      json: {
        payment_id: paymentId.value,
        amount: amount.value,
        booking_id: Number(props.bookingId),
      },
    });

    if ("body" in response && [200, 201].includes(response.status)) {
      successMessage.value = "Payment processed successfully!";
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Payment processing failed.";
    }
  } catch {
    errorMessage.value = "An error occurred during payment processing.";
  }

  submitting.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        class: "btn",
        to: {
        name: 'nb_booking_detail',
        params: { bookingId: __props.bookingId, facilityId: __props.facilityId, facilityName: __props.facilityName },
      }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, "Booking #" + _toDisplayString(__props.bookingId), 1)
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 0,
            variant: "danger",
            dismissible: "",
            onDismissed: _cache[0] || (_cache[0] = ($event: any) => (errorMessage.value = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (successMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(successMessage.value) + " ", 1),
              _createVNode(_component_RouterLink, {
                class: "btn btn-sm",
                to: {
          name: 'nb_booking_detail',
          params: { bookingId: __props.bookingId, facilityId: __props.facilityId, facilityName: __props.facilityName },
        }
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (step.value === 1 && !successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("form", {
              onSubmit: _withModifiers(authorizeCard, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cardName).value = $event)),
                    type: "text",
                    required: ""
                  }, null, 512), [
                    [_vModelText, cardName.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cardNumber).value = $event)),
                    type: "text",
                    required: "",
                    maxlength: "19"
                  }, null, 512), [
                    [_vModelText, cardNumber.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((expiryMonth).value = $event)),
                    required: ""
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                      return _createElementVNode("option", {
                        key: m,
                        value: String(m).padStart(2, '0')
                      }, _toDisplayString(String(m).padStart(2, "0")), 9, _hoisted_18)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, expiryMonth.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((expiryYear).value = $event)),
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearOptions), (y) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: y,
                        value: String(y)
                      }, _toDisplayString(y), 9, _hoisted_21))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, expiryYear.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ccv).value = $event)),
                    type: "text",
                    required: "",
                    maxlength: "4"
                  }, null, 512), [
                    [_vModelText, ccv.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((amount).value = $event)),
                    type: "number",
                    step: "0.01",
                    min: "0.01",
                    required: ""
                  }, null, 512), [
                    [_vModelText, amount.value]
                  ])
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-blue",
                type: "submit",
                disabled: submitting.value
              }, _toDisplayString(submitting.value ? "Authorizing..." : "Authorize Card"), 9, _hoisted_27)
            ], 40, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      (step.value === 2 && !successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("p", null, [
              _hoisted_30,
              _createElementVNode("strong", null, _toDisplayString(paymentId.value), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_31,
              _createElementVNode("strong", null, "$" + _toDisplayString(amount.value), 1)
            ]),
            _createElementVNode("button", {
              class: "btn btn-blue",
              disabled: submitting.value,
              onClick: processPayment
            }, _toDisplayString(submitting.value ? "Processing..." : "Process Payment"), 9, _hoisted_32),
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (step.value = 1))
            }, "Cancel")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})